import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function RateIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="24" height="20" rx="4" fill={props.fill} />
			<path opacity="0.5" d="M8 23L11.6364 18L16 23" stroke="#BCBBD0" strokeWidth="2" strokeLinecap="round" />
			<path fillRule="evenodd" clipRule="evenodd" d="M9.00081 9.53431C7.97622 10.5166 6.69472 11.7067 4.11051 11.9938C3.56161 12.0548 3.06719 11.6593 3.0062 11.1104C2.94522 10.5615 3.34075 10.067 3.88965 10.0061C5.80542 9.7932 6.68553 8.98333 7.61674 8.09061C7.64279 8.06563 7.6691 8.04037 7.69566 8.01485C8.14593 7.58233 8.67225 7.07675 9.32451 6.69286C10.0498 6.26598 10.9034 6 12 6C14.0791 6 15.474 6.66021 16.6567 7.24707C16.689 7.26312 16.7211 7.27907 16.753 7.29492C17.8818 7.85554 18.7478 8.28568 20 8.28568C20.5523 8.28568 21 8.73339 21 9.28566C21 9.83794 20.5523 10.2856 20 10.2856C18.2693 10.2856 17.0261 9.66585 15.9409 9.12481C15.8827 9.09581 15.825 9.06703 15.7676 9.03858C14.6472 8.4826 13.5978 7.99997 12 7.99997C11.2583 7.99997 10.7552 8.17149 10.339 8.41647C9.89306 8.67889 9.51945 9.03708 9.01751 9.5183L9.00081 9.53431Z" fill="white" />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M18.6986 5.03956C18.3613 5.31612 18.0298 5.6739 17.8373 6L16 5.22161C16.3211 4.67745 16.8113 4.16496 17.27 3.78881C17.5017 3.59886 17.7482 3.42479 17.9885 3.29158C18.1084 3.22511 18.2437 3.15937 18.388 3.10772C18.5197 3.06055 18.7272 3 18.9729 3C19.5401 3 20 3.38963 20 3.87027C20 4.29901 19.6341 4.65534 19.1524 4.72729C19.1418 4.73263 19.1287 4.73949 19.1131 4.74811C19.01 4.80527 18.8649 4.90316 18.6986 5.03956Z" fill="white" />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M11.9904 11.5378C12.743 11.1208 13.2332 10.5975 13.6679 9.94531L15.332 11.0547C14.7668 11.9025 14.057 12.6792 12.9596 13.2872C11.8806 13.885 10.4898 14.2851 8.61043 14.4939C8.06152 14.5549 7.5671 14.1594 7.50611 13.6104C7.44512 13.0615 7.84066 12.5671 8.38957 12.5061C10.1102 12.3149 11.2194 11.965 11.9904 11.5378Z" fill="white" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<RateIcon fill={props.fill} />
		</div>
	);
}